const NotFoundPage = () => (
  <div className="absolute left-1/2 -translate-x-1/2 bottom-1/2 -translate-y-1/2">
    <div className="text-xl md:text-4xl text-gray-500 flex font-Header-B gap-4">
      <p>
        404
      </p>
      <p>
        |
      </p>
      <p className="uppercase">
        Not Found
      </p>
    </div>  
  </div>
)

export default NotFoundPage
